import * as React from "react";
import "./App.css";
import NavBarLayout from "./NavbarLayout";
import logo from "./icons/Animated Logo.gif";
import Button from "@mui/material/Button";
import HangerIcon from "./icons/hanger bar.png";
import { useNavigate } from "react-router-dom";
import { buttonStyle } from "./colors";
import Outfit1 from "./outfits/outfit 1.png";
import Outfit21 from "./outfits/outfit 21.png";
import Outfit19 from "./outfits/outfit 19.png";
import Outfit18 from "./outfits/outfit 18.png";
import Outfit17 from "./outfits/outfit 17.png";

const AUTO_OUTFITS = [Outfit17, Outfit18, Outfit19];
const MANUAL_OUTFITS = [Outfit1, Outfit21];

function Home() {
  const navigate = useNavigate();
  const [temperature, setTemperature] = React.useState(
    sessionStorage.getItem("temperature")
  );
  const closetRef = React.useRef();
  const [closetHeight, setClosetHeight] = React.useState(300);

  let date = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
  date = date.split("");
  date.splice(6, 2);
  date = date.join("");

  React.useEffect(() => {
    if (closetRef.current) {
      setClosetHeight(closetRef.current.clientHeight);
    }
  }, [closetRef]);

  React.useEffect(() => {
    (async () => {
      if (temperature == null) {
        const response = await fetch(
          "https://api.open-meteo.com/v1/forecast?latitude=37.468319&longitude=-122.143936&current=temperature_2m&temperature_unit=fahrenheit"
        );
        const data = await response.json();
        setTemperature(data.current.temperature_2m);
        sessionStorage.setItem("temperature", data.current.temperature_2m);
      }
    })();
  }, []);

  const outfitIndex = sessionStorage.getItem("outfitIndex");
  const method = sessionStorage.getItem("method");

  return (
    <NavBarLayout hideTitlebar active={0}>
      <div className="Home-outerContainer">
        <div className="Home-container">
          <div className="Home-logoContainer">
            <img className="Home-logo" src={logo} alt="" />
          </div>
          <div className="Home-smallTextContainer">
            <span className="Home-smallText">Palo Alto, CA</span>
            <span className="Home-smallText">{temperature}°F</span>
          </div>
          <div ref={closetRef} className="Home-closet">
            <span className="Home-closetTitleText">Your #OOTD</span>
            <img style={{ width: "100%" }} src={HangerIcon} alt="" />
            {outfitIndex == null ? (
              <span className="Home-closetText">
                Make your #OOTD to have it show up here!
              </span>
            ) : (
              <img
                style={{
                  position: "absolute",
                  top: 105,
                  height: `calc(${closetHeight}px - 105px - 1rem)`,
                }}
                src={
                  method === "manual"
                    ? MANUAL_OUTFITS[outfitIndex]
                    : AUTO_OUTFITS[outfitIndex]
                }
                alt=""
              />
            )}
          </div>
          <Button
            onClick={() => navigate("/outfitmethods")}
            sx={buttonStyle}
            variant="contained"
          >
            Make my #OOTD
          </Button>
        </div>
      </div>
    </NavBarLayout>
  );
}

export default Home;
